module.exports = __webpack_public_path__ + "img/Aries.4f375fcd.png";